<!-- eslint-disable max-len -->
<route>
{
  "meta": {
    "requireAdmin": true,
    "customSite": true
  }
}
</route>
<template>
  <div class="py-1 px-3">
    <div class="grid grid-cols-2 items-center mb-4">
      <div class="text-xl">Course Creators</div>
      <!--
      <div class="text-xl text-right">
        <button type="button" class="btn btn-primary" @click="setModalDetails('enrolled')">
          Send DM
        </button>
        <button type="button" class="btn ml-3 btn-primary" @click="downloadCSVEnrolled">
          Export
        </button>
      </div>
      -->
    </div>
    <div class="pb-8">
      <div class="border-b border-gray-200">
        <table class="min-w-full divide-y divide-gray-200">
          <thead class="bg-white">
            <tr>
              <th
                scope="col"
                class="px-6 py-3 text-left text-xs font-bold text-gray-900 uppercase tracking-wider"
              >
                #
              </th>
              <th
                scope="col"
                class="px-6 py-3 text-left text-xs font-bold text-gray-900 uppercase tracking-wider"
              >
                Name
              </th>
              <th
                scope="col"
                class="px-6 py-3 text-left text-xs font-bold text-gray-900 uppercase tracking-wider"
              >
                Email
              </th>
              <th scope="col" class="px-6 py-3 text-right">
                Show courses
              </th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
            <tr v-for="(creator, index) in creators" :key="index">
              <td class="px-6 py-4 whitespace-nowrap font-thin text-gray-500">
                {{ index + 1 }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-gray-900">
                {{ creator.userName }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-gray-900">
                {{ creator.userEmail }}
              </td>
              <td class="px-6 py-3 text-right">
              <button type="button" class="btn btn-primary" @click="showCourses(creator.userId)">
                Show
              </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store';
import userInfo from '@/services/userInfo';
import utils from '@/services/utils';

export default {
  name: 'courseCreators',
  layout: 'admin',
  store,
  data() {
    return {
      creators: [],
    };
  },
  async mounted() {
    store.commit('toggleLoading', true);
    userInfo
      .getCoursecreators()
      .then((data) => {
        store.commit('toggleLoading', false);
        this.creators = data.courseCreators;
        console.log(data.courseCreators);
      })
      .catch((error) => {
        store.commit('toggleLoading', false);
        if (error.response.status === 401) {
          utils.setStatusMsg(this, 'Unauthorized access, redirected to implicit');
          this.$router.push({ path: '/' });
        }
        console.log({ error });
      });
  },
  methods: {
    showCourses(id) {
      this.$router.push({ path: `/admin/course-creators/${id}` });
    },
  },
};
</script>
